import React from "react";

export default class ComponentToPrint extends React.Component {
    render() {
        const data = (this.props.data).slice();
        const summeryData = (this.props.summeryData).slice();
        const selectedSearchValues = this.props.selectedSearchValues;
        const summeryValuesOne = this.props.summeryValuesOne;
        const originalDataCount = data.slice()

        const summaryStaticDataArray = [
            'Tree Scrap.............................. Kgs. % Wet Wt. ..............................',
            'Shell Scrap.............................. Kgs. % Wet Wt. ..............................',
            'Bark Scrap.............................. Kgs. % Wet Wt. ..............................',
            'Earth Scrap.............................. Kgs. % Wet Wt. ..............................',
            'Total Scrap Kgs...............................',
            'Average Tapper Latex.............................. Kgs.',
            'Average Tapper Scrap.............................. Kgs.',
            'Average Tapper Total.............................. Kgs.'
        ]

        const chunkedTotalValues = this.calculateChunkTotals(data, 25)
        const chunkedData = this.chunkArray(data, 25);
        const chunkedSummary = this.chunkArray(summeryData, 8)
        return (
            <div style={{ width: '100%', marginTop: -40 }}>
                {chunkedData.map((chunk, index) => (
                    <div className="pdf-head">
                        <h3 style={{ fontWeight: "bold" }}><center>{selectedSearchValues.group}</center></h3>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div><b>TAPPING MANUAL CHECKLIST</b></div>
                            <div style={{ marginLeft: 'auto' }}><b> {selectedSearchValues.checklistID}</b></div>
                            <div style={{ marginLeft: 'auto' }}><b> {"Job Type : " + selectedSearchValues.jobType}</b></div>
                            <div ></div>
                        </div>
                        <div className="pdf-root">
                            <table className="head-table">
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Initial of Field Officer</th>
                                        <th></th>
                                        <th>Norm / Task</th>
                                        <th></th>
                                        <th>Date</th>
                                        <th>{selectedSearchValues.date}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Estate</td>
                                        <td>{selectedSearchValues.operationEntity}</td>
                                        <td colSpan={5}>Name and Initial of Field Asst.</td>
                                    </tr>
                                    <tr>
                                        <td>Division</td>
                                        <td>{selectedSearchValues.division}</td>
                                        <td colSpan={3}>No. of Workers at Musters :
                                            {index == 0 ? originalDataCount.length : ''}
                                        </td>
                                        <td colSpan={2}>Muster Distributed by :(Sign)</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>Field Officer:</td>
                                        <td colSpan={3}>Supervisor</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="data-table" id="data-table">
                                <thead>
                                    <tr style={{ height: '30px', fontSize: '9px' }}>
                                        <th style={{ width: '17px' }}></th>
                                        <th style={{ width: '50px' }}>E.P.F<br />No</th>
                                        <th style={{ width: '130px' }}>Name</th>
                                        <th style={{ width: '35px', fontSize: '8px' }}>Normal<br />O.T.</th>
                                        <th style={{ width: '100px' }}>Field<br />No.</th>
                                        <th style={{ width: '30px' }}>Block<br />No.</th>
                                        <th>No. of<br />Litres</th>
                                        <th>Metrolac<br />Reading</th>
                                        <th>Latex<br />Kgs.</th>
                                        <th>Scrap<br />Kgs.</th>
                                        <th style={{ width: '35px' }}>Over<br />Kgs</th>
                                        <th style={{ width: '25px' }}>Day</th>
                                        <th style={{ width: '35px' }}>OT&nbsp;Job<br />Code</th>
                                        <th style={{ width: '30px' }}>OT<br />Hours</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chunk.map((row, index) => (
                                        <tr style={{ fontSize: '8px' }}>
                                            <td>{index + 1}</td>
                                            <td>{row.registrationNumber}</td>
                                            <td className='table-name-col' style={{ fontSize: '7px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div style={{ alignContent: 'left' }}>
                                                        {row.firstName}
                                                    </div>
                                                    {row.collectionTypeCode == "PC" ?
                                                        <div style={{ alignContent: 'right' }}>
                                                            (PC)
                                                        </div> : null}
                                                </div>
                                            </td>
                                            <td></td>
                                            <td className='table-name-col'>{row.fieldName}</td>
                                            <td></td>
                                            <td>{row.totalLitres != undefined ? row.totalLitres.toFixed(2) : ''}</td>
                                            <td>{row.metrolacValue != undefined ? row.metrolacValue.toFixed(2) : ''}</td>
                                            <td>{row.latex != undefined ? row.latex.toFixed(2) : ''}</td>
                                            <td>{row.scrap != undefined ? row.scrap.toFixed(2) : ''}</td>
                                            <td></td>
                                            <td></td>
                                            <td>{row.taskCode != undefined ? row.taskCode : ''}</td>
                                            <td>{row.otHours != undefined ? row.otHours.toFixed(2) : ''}</td>
                                        </tr>
                                    ))}
                                    <tr style={{ fontSize: '8px' }}>
                                        <td colSpan={2}></td>
                                        <td>Total</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{(chunkedTotalValues[index].totalLitres).toFixed(2)}</td>
                                        <td></td>
                                        <td>{(chunkedTotalValues[index].totalLatex).toFixed(2)}</td>
                                        <td>{(chunkedTotalValues[index].totalScrap).toFixed(2)}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{(chunkedTotalValues[index].totalotHours).toFixed(2)}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="summary-table" style={{ marginTop: '5px' }}>
                                <thead>
                                    <tr style={{ fontSize: '8px' }}>
                                        <th style={{ width: '100px' }}>Field<br />No.</th>
                                        <th style={{ width: '30px' }}>No. of<br />Tappers</th>
                                        <th style={{ width: '30px' }}>DT<br />Blocks</th>
                                        <th style={{ width: '30px' }}>Vacant<br />Blocks</th>
                                        <th>Latex<br />Litres</th>
                                        <th>Latex<br />Kgs.</th>
                                        <th>Scrap<br />Kgs</th>
                                        <th>Total<br />Kgs</th>
                                        <th className='table-name-col' style={{ width: '300px', paddingLeft: '2px' }}>Total Latex Kgs ..............................</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chunkedSummary[index] != undefined ? (chunkedSummary[index].map((row, index) => (
                                        <tr style={{ fontSize: '8px' }}>
                                            <td className='table-name-col'>{row.fieldName}</td>
                                            <td>{row.empCount}</td>
                                            <td></td>
                                            <td></td>
                                            <td>{row.totalLitres != undefined ? row.totalLitres.toFixed(2) : 0.00}</td>
                                            <td>{row.latex != undefined ? row.latex.toFixed(2) : 0.00}</td>
                                            <td>{row.scrap != undefined ? row.scrap.toFixed(2) : 0.00}</td>
                                            <td>{row.total != undefined ? row.total.toFixed(2) : 0.00}</td>
                                            <td className='table-name-col'>{summaryStaticDataArray[index]}</td>
                                        </tr>
                                    ))) :
                                        summaryStaticDataArray.map((row, idx) => (
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td className='table-name-col'>{summaryStaticDataArray[idx]}</td>
                                            </tr>
                                        ))
                                    }
                                    <tr>
                                        <td><b>Total</b></td>
                                        <td>{chunkedData.length - 1 == index ? summeryValuesOne.totalempCount : ''}</td>
                                        <td></td>
                                        <td></td>
                                        <td>{chunkedData.length - 1 == index ? summeryValuesOne.totalLitres : ''}</td>
                                        <td>{chunkedData.length - 1 == index ? summeryValuesOne.totallatex : ''}</td>
                                        <td>{chunkedData.length - 1 == index ? summeryValuesOne.totalscrap : ''}</td>
                                        <td>{chunkedData.length - 1 == index ? summeryValuesOne.alltotal : ''}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <center style={{ fontSize: '9px' }}>
                            <div className="row pb-0 pt-4">
                                <div className="col"> </div>
                                <div className="col"> </div>
                                <div className="col">Authorized by</div>
                                <div className="col">Checked by</div>
                                <div className="col">Approved by</div>
                            </div>
                            <div className="row pb-0 pt-3">
                                <div className="col">Weighing done by </div>
                                <div className="col">.............................. </div>
                                <div className="col">..............................</div>
                                <div className="col">.............................</div>
                                <div className="col">..............................</div>
                            </div>
                            <div className="row pb-0 pt-0">
                                <div className="col"> (Field) </div>
                                <div className="col"> </div>
                                <div className="col">Asst Supdt.</div>
                                <div className="col">Div.Clerk</div>
                                <div className="col">Supd</div>
                            </div>
                        </center>
                        {chunkedData.length - 1 !== index ? <div className='pagebreak'></div> : <div></div>}
                    </div>
                ))}
            </div>
        );
    }
    chunkArray(array, size) {
        let i = array.length % size == 0 ? 25 : array.length % size
        for (i; i < 25; i++) {
            array.push({ empty: true })
        }
        const chunkedArr = [];
        let index = 0;
        while (index < array.length) {
            chunkedArr.push(array.slice(index, size + index));
            index += size;
        }
        return chunkedArr;
    }

    calculateChunkTotals(array, size) {
        const chunkedArr = [];
        let index = 0;
        while (index < array.length) {
            chunkedArr.push(array.slice(index, size + index));
            index += size;
        }
        let totalLatex = 0
        let totalMetrolac = 0
        let totalLitres = 0
        let totalScrap = 0
        let totalotHours = 0
        let chunkedTotals = []
        let chuckTotalData = {}
        for (let i = 0; chunkedArr.length > i; i++) {
            for (let j = 0; j < chunkedArr[i].length; j++) {
                totalLatex += chunkedArr[i][j].latex == undefined ? 0 : chunkedArr[i][j].latex
                totalMetrolac += chunkedArr[i][j].metrolacValue == undefined ? 0 : chunkedArr[i][j].metrolacValue
                totalLitres += chunkedArr[i][j].totalLitres == undefined ? 0 : chunkedArr[i][j].totalLitres
                totalScrap += chunkedArr[i][j].scrap == undefined ? 0 : chunkedArr[i][j].scrap
                totalotHours += chunkedArr[i][j].otHours == undefined ? 0 : chunkedArr[i][j].otHours
            }
            chuckTotalData = {
                totalLatex,
                totalMetrolac,
                totalLitres,
                totalScrap,
                totalotHours
            }
            chunkedTotals.push(chuckTotalData)
            totalLatex = 0
            totalMetrolac = 0
            totalLitres = 0
            totalScrap = 0
            totalotHours = 0
        }
        return chunkedTotals
    }
}


